import { IWB_LIGHT_THEME } from './light.mjs';
import { IWB_DARK_THEME } from './dark.mjs';
export const IWB_THEME={light: IWB_LIGHT_THEME, dark: IWB_DARK_THEME};
